import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useRedirectGuard = (
	shouldRedirect: boolean,
	redirectTo: string,
) => {
	const navigate = useNavigate();

	useEffect(() => {
		if (shouldRedirect) {
			navigate(redirectTo, { replace: true });
		}
	}, [shouldRedirect, redirectTo, navigate]);
};
